// extracted by mini-css-extract-plugin
export var askAiIcon = "_ph-9";
export var container = "_ph-0";
export var groupSeparator = "_ph-a";
export var highlight = "_ph-4";
export var resultIcon = "_ph-5";
export var resultItem = "_ph-7";
export var resultSubtitle = "_ph-3";
export var resultTitle = "_ph-2";
export var resultsList = "_ph-1";
export var searchGroup = "_ph-6";
export var selected = "_ph-8";